import { CheckIcon } from '@chakra-ui/icons';
import { FormControl, IconButtonProps, Input, InputGroup, InputRightAddon, Stack, useBoolean } from '@chakra-ui/react';
import cuid from 'cuid';
import { FC } from 'react';
import { IoIosCopy } from 'react-icons/io';

import { AddonIconTextButton } from './AddonIconButton';

interface IInputCopyField extends IconButtonProps {
  field: {
    value: any;
    label: string;
  };
  copy: {
    currentCopiedValue: any;
    handleCopy: (val: any) => void;
    copyValue?: any;
  };
  customContent?: any;
  copyBttnWidth?: string;
  preventLastPassAutoFill?: boolean;
}

const InputCopyField: FC<IInputCopyField> = ({
  field: { value, label },
  copy: { handleCopy, copyValue = value },
  customContent = null,
  copyBttnWidth = '20px',
  preventLastPassAutoFill,
}) => {
  const [showCheckIcon, setShowCheckIcon] = useBoolean(false);
  const SHOW_CHECKICON_DURATION = 700;

  return (
    <Stack width={'100%'}>
      <FormControl id={cuid()}>
        <InputGroup>
          <Input type={'text'} errorBorderColor="status.error" value={value ?? ''} readOnly data-lpignore={preventLastPassAutoFill} />
          <InputRightAddon p={0} minWidth={20}>
            <AddonIconTextButton
              icon={showCheckIcon ? <CheckIcon /> : <IoIosCopy />}
              aria-label={'copy credentials username button'}
              onClick={() => {
                setShowCheckIcon.on();
                handleCopy(copyValue);
                setTimeout(setShowCheckIcon.off, SHOW_CHECKICON_DURATION);
              }}
            >
              {label}
            </AddonIconTextButton>
          </InputRightAddon>
        </InputGroup>
      </FormControl>
      <p style={{ width: copyBttnWidth }}> {customContent}</p>
    </Stack>
  );
};

export default InputCopyField;
